<template>
<main class="G_DisplayColumnWrap L_ShopCategoryHolder">
    <div class="G_DisplayRowNowrap L_ShopBackButtonHolder">
        <button class="G_Button G_Border G_BorderRadius G_NormalFont L_ShopBackButton" @click="SetSelectedComp('Shop')">Back</button>
    </div>
    <div class="G_DisplayRowWrap L_ShopItemsHolder">
        <div class="G_DisplayColumnNowrap G_BorderRadius G_Border L_ShopItem" v-for="ShopItem in ShopItems" :key="ShopItem" :style="{ backgroundImage: 'url(\''+this.FixImage(ShopItem).ImagePath+'\')' }">
            <div class="G_DisplayRowNowrap G_HeadingFont L_InfoHolder">
                <div class="fa G_DisplayRowNowrap L_InfoIcon" @click="OpenProductInfo(ShopItem)">
                    &#xf05a;
                </div>
            </div>
            <div class="L_EmptySpace">

            </div>
            <div class="G_DisplayRowNowrap G_NormalFont G_BorderRadius L_ShopItemName">
                {{ShopItem.Description}} - R{{ ShopItem.Price }}
            </div>
            <div class="G_DisplayRowNowrap L_BasketButtonHolder">
                <button class="G_BorderRadius G_Border G_NormalFontWhite L_BasketButton" @click="addToBasket(ShopItem)"><span class="L_ButtonCaption">{{ ShopItem.BasketButtonCaption }}</span></button>
            </div>
        </div>
    </div>

    <TSTProductPopup v-if="ProductInfo" :ProductInfoData="ProductInfoData" @CloseProductInfo="() => this.CloseProductInfo()" />
    <TSTAlert v-if="AddedToBasket" :AlertDescription="'Added to basket!'" :class="AlertClass" />
</main>
</template>

<script>
import FudgeAmarula from '../../../../assets/images/shop/categories/fudge/Amarula.jpg'
import FudgeBubbly from '../../../../assets/images/shop/categories/fudge/Bubbly.jpg'
import FudgeChocOreo from '../../../../assets/images/shop/categories/fudge/ChocOreo.jpg'
import FudgeCookiesAndCream from '../../../../assets/images/shop/categories/fudge/CookiesAndCream.jpg'
import FudgeMilktart from '../../../../assets/images/shop/categories/fudge/Milktart.jpg'
import FudgeMilkyBar from '../../../../assets/images/shop/categories/fudge/MilkyBar.jpg'
import FudgeOreo from '../../../../assets/images/shop/categories/fudge/Oreo.jpg'
import FudgeRolo from '../../../../assets/images/shop/categories/fudge/Rolo.jpg'
import FudgeRomanyCreams from '../../../../assets/images/shop/categories/fudge/RomanyCreams.jpg'
import FudgeSpeckledEggs from '../../../../assets/images/shop/categories/fudge/SpeckledEggs.jpg'
import FudgeTopDeck from '../../../../assets/images/shop/categories/fudge/TopDeck.jpg'
import FudgeTraditional from '../../../../assets/images/shop/categories/fudge/Traditional.jpg'

import BrowniePlain from '../../../../assets/images/shop/categories/brownies/BrowniePlain.jpg'
import BrownieSpeckled from '../../../../assets/images/shop/categories/brownies/BrownieSpeckled.jpg'
import BrownieTub from '../../../../assets/images/shop/categories/brownies/BrownieTub.jpg'

import ChocMarie from '../../../../assets/images/shop/categories/other/ChocMarie.jpg'
import CoconutIce from '../../../../assets/images/shop/categories/other/CoconutIce.jpg'
import RiceKrispy from '../../../../assets/images/shop/categories/other/RiceKrispy.jpg'
import RockyRoad from '../../../../assets/images/shop/categories/other/RockyRoad.jpg'

import TSTProductPopup from '../../../widgets/TSTProductPopup.vue'
import TSTAlert from '../../../widgets/TSTAlert.vue'
import axios from 'axios'

export default {
    components: {
        TSTProductPopup,
        TSTAlert
    },
    props: [
        'ShopItems'
    ],
    created() {
        this.SetExistingBasketItems();
    },
    data() {
        return {
            ShopImages: [
                FudgeAmarula, FudgeBubbly, FudgeChocOreo, FudgeCookiesAndCream, FudgeMilktart, FudgeMilkyBar, FudgeOreo, FudgeRolo, FudgeRomanyCreams,
                FudgeSpeckledEggs, FudgeTopDeck, FudgeTraditional, BrowniePlain, BrownieSpeckled, BrownieTub, ChocMarie, CoconutIce,
                RiceKrispy, RockyRoad
            ],
            ProductInfo: false,
            ProductInfoData: {},
            AddedToBasket: false,
            AlertClass: "L_AlertHolderNoShowShop",
            BasketItems: []
        }
    },
    methods: {
        SetExistingBasketItems() {
            if (window.localStorage.getItem("BasketItems") != "undefined") {
                var ExistinBasketItems = JSON.parse(window.localStorage.getItem("BasketItems"));
                if (!this.isEmpty(ExistinBasketItems) && this.isEmpty(this.BasketItems)) {
                    this.BasketItems = ExistinBasketItems;
                } else {
                    window.localStorage.setItem("BasketItems", JSON.stringify(this.basketItems));
                }
            }
        },
        FixImage(ShopItem) {
            for (var ShopImage in this.ShopImages) {
                ShopImage = this.ShopImages[ShopImage]
                var ImageName = ShopItem.ImagePath.split(".jpg")[0]

                if (ShopImage.includes(ImageName)) {
                    ShopItem.ImagePath = ShopImage
                }
            }

            return ShopItem
        },
        SetSelectedComp(ShopItems) {
            this.$emit('SetSelectedComp', 'Shop')
        },
        OpenProductInfo(ProductInfoData) {
            this.ProductInfo = true
            this.ProductInfoData = ProductInfoData
        },
        CloseProductInfo() {
            this.ProductInfo = false
        },
        async addToBasket(ShopItem) {
            this.AddedToBasket = true
            this.AlertClass = "L_AlertShowShop"

            var scope = this

            setTimeout(
                function () {
                    scope.AlertClass = "L_AlertHolderNoShowShop"
                }, 1000
            )

            var PushedShopItem = {}
            PushedShopItem.Description = ShopItem.Description
            PushedShopItem.Price = ShopItem.Price
            PushedShopItem.ImagePath = ShopItem.ImagePath
            PushedShopItem.Qty = ShopItem.Qty

            var BasketItemAdded = this.BasketItems.some(function (BasketItem) {
                return BasketItem.Description === PushedShopItem.Description
            });

            if (!BasketItemAdded) {
                this.BasketItems.push(PushedShopItem)
            }

            window.localStorage.setItem("BasketItems", JSON.stringify(this.BasketItems));

            this.$emit("UpdateBasket", this.BasketItems);
        },
        isEmpty(Val) {
            if (!Val) return true;
            if (typeof Val == "object" && Object.keys(Val).length === 0) return true;
            if (typeof Val == "array" && Val.length === 0) return true;
            return false;
        }
    }
}
</script>

<style lang="scss">
@import "../../../../assets/GlobalCss.scss";

>.L_ShopCategoryHolder {
    width: 100%;
    justify-content: center;
    align-items: center;
}

.L_ShopBackButtonHolder {
    width: 100%;
    margin-top: 1rem;
    margin-left: 2rem;

    @include mobile() {
        width: 90%;
    }
}

.L_ShopItemsHolder {
    width: 100%;
    justify-content: space-around;
    align-items: center;

    @include mobile() {
        width: 100%;
        justify-content: center;
    }
}

.L_ShopItem {
    width: 28%;
    height: 20rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    background-size: 100% 100%;
    align-items: center;
    justify-content: space-between;

    @include mobile() {
        width: 85%;
        height: 20rem;
    }
}

.L_InfoHolder {
    width: 100%;
    height: 10%;
    justify-content: flex-end;
}

.L_InfoIcon {
    width: 1.5rem;
    height: 1.5rem;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
    border-radius: 100%;
    color: #F3CBBB;
    cursor: pointer;
    margin: .5rem;
}

.L_EmptySpace {
    height: 50%;
}

.L_ShopItemName {
    width: 70%;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
    box-shadow: 5px 5px #888888;
    margin-bottom: .2rem;
}

.L_BasketButton {
    margin-bottom: 1rem;
    width: 13rem;
    background-color: #F3CBBB;
    cursor: pointer;
}

.L_BasketButton:hover {
    transition: .2s ease;
    background-color: #FFFFFF;
    color: #F3CBBB;
}

.L_AlertHolderNoShowShop {
    display: none;
}

.L_AlertShowShop {
    position: absolute;
    animation: AlertShop 1s ease-in-out forwards;
}

@keyframes AlertShop {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
</style>
